import React, { useState, useRef, useEffect } from 'react';
import { 
  FunnelIcon, 
  CheckIcon,
  ChevronUpDownIcon
} from '@heroicons/react/24/outline';

const CategoryDropdown = ({ categories, setCategories }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggleCategory = (categoryId) => {
    setCategories(categories.map(category => 
      category.id === categoryId 
        ? { ...category, checked: !category.checked }
        : category
    ));
  };

  const checkedCount = categories.filter(cat => cat.checked).length;
  const totalCount = categories.length;

  const handleSelectAll = () => {
    const allChecked = categories.every(cat => cat.checked);
    setCategories(categories.map(category => ({
      ...category,
      checked: !allChecked
    })));
  };

  return (
    <div className="dropdown dropdown-end" ref={dropdownRef}>
      <button
        className="btn btn-sm normal-case gap-2"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FunnelIcon className="w-4 h-4" />
        <span>
          {checkedCount === totalCount 
            ? 'Alle Kategorien' 
            : `${checkedCount} von ${totalCount}`}
        </span>
        <ChevronUpDownIcon className="w-4 h-4" />
      </button>

      {isOpen && (
        <div className="dropdown-content z-[1] menu p-2 shadow-lg bg-base-100 rounded-lg w-60 mt-2 ring-1 ring-base-content/5">
          <div className="p-2">
            <button
              onClick={handleSelectAll}
              className="btn btn-sm btn-ghost normal-case w-full justify-start gap-2"
            >
              <CheckIcon className="w-4 h-4" />
              {categories.every(cat => cat.checked) ? 'Alle abwählen' : 'Alle auswählen'}
            </button>
            <div className="divider my-2"></div>
            <ul className="space-y-1">
              {categories.map((category) => (
                <li key={category.id}>
                  <label className="flex items-center gap-3 p-2 rounded-lg hover:bg-base-200 cursor-pointer">
                    <input
                      type="checkbox"
                      className="checkbox checkbox-sm"
                      checked={category.checked}
                      onChange={() => handleToggleCategory(category.id)}
                    />
                    <span className="flex-1 text-sm">
                      {category.name}
                    </span>
                  </label>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryDropdown;
